/**
 * Returns closest value from array
 * @param {Array} arr
 * @param {number} val
 */
export function getClosestValue(arr = [], val) {
    return arr.reduce((prev, curr) => {
        return (Math.abs(curr - val) < Math.abs(prev - val) ? curr : prev);
    });
}

/**
 * Returns random value from array
 * @param {Array} arr
 * @returns {Object}
 */
export function get_array_rand(arr)
{
	return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * Check if array contains a value
 * @param {Array} arr
 * @param {Object} v
 * @returns {boolean}
 */
export function array_contains(arr, v)
{
    for(var i = 0; i < arr.length; i++) {
        if(arr[i] === v) return true;
    }
    return false;
}

/**
 * Returns unique values from array
 * @param {Array} arr
 * @returns {Array}
 */
export function array_unique(arr)
{
	var arr2 = [];

	for(var i = 0; i < arr.length; i++) {
        if(!array_contains(arr2, arr[i])) {
            arr2.push(arr[i]);
        }
    }

    return arr2;
}

/**
 * Returns a random integer between min (inclusive) and max (inclusive)
 */
export function get_random_int(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns max value from array
 * @param {Array} numArray
 */
export function get_array_max(numArray)
{
	return Math.max.apply(null, numArray);
}

/**
 * Returns max value from array
 * @param {Array} numArray
 */
export function get_array_min(numArray)
{
	return Math.min.apply(null, numArray);
}

/**
 * Shuffles array in place.
 * @param {Array} a items The array containing the items.
 */
export function array_shuffle(a) {
    var j;
	var x;
	var i;

    for ( i = a.length; i; i--) {
        j = Math.floor(Math.random() * i);
        x = a[i - 1];
        a[i - 1] = a[j];
        a[j] = x;
    }

	return a;
}

export function to_radians(deg) {
	return deg * (Math.PI / 180);
}

export function to_degrees(rad) {
	return rad * (180 / Math.PI);
}